import api from "services/api";
import { toSearchFilter } from "../utils";
import { API_URL_VERSION } from "constants/environment";

export const DOCUMENTS = API_URL_VERSION + "documentos";
export const ENDPOINT_DOCUMENTS_LIST = `${DOCUMENTS}/listar`;
export const ENDPOINT_DOCUMENTS_LIST_PATH = (parentType, parentId) =>
  `${ENDPOINT_DOCUMENTS_LIST}/tipo/${parentType}/entidade/${parentId}`;

export const documentsService = {
  list: async (params = {}, parentType, parentId) => {
    try {
      const response = await api.post(ENDPOINT_DOCUMENTS_LIST_PATH(parentType, parentId), toSearchFilter(params));
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "documents.messages.errors.list";
    }
  },

  createDocument: async (data, id) => {
    try {
      const response = await api.post(`${DOCUMENTS}/${id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "documents.messages.errors.create";
    }
  },

  create: async (data) => {
    try {
      const response = await api.post(DOCUMENTS, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "documents.messages.errors.create";
    }
  },

  updateDocument: async (data, id) => {
    try {
      const response = await api.put(`${DOCUMENTS}/${id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "documents.messages.errors.update";
    }
  },

  update: async (data) => {
    try {
      const response = await api.put(DOCUMENTS, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "documents.messages.errors.update";
    }
  },

  attachment: async (parentType, parentID, id, fileName) => {
    try {
      const response = await api.get(`${DOCUMENTS}/anexo/tipo/${parentType}/entidade/${parentID}/${id}/${fileName}`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "documents.messages.errors.find";
    }
  },

  deleteAttachment: async (parentType, parentID, id, fileName) => {
    try {
      const response = await api.delete(`${DOCUMENTS}/anexo/tipo/${parentType}/entidade/${parentID}/${id}/${fileName}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "documents.messages.errors.attachment-delete";
    }
  },

  find: async (parentType, parentID, id) => {
    try {
      const response = await api.get(`${DOCUMENTS}/tipo/${parentType}/entidade/${parentID}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "documents.messages.errors.find";
    }
  },

  findMany: async (parentType, parentID) => {
    try {
      const response = await api.get(`${DOCUMENTS}/tipo/${parentType}/entidade/${parentID}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "documents.messages.errors.list";
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`${DOCUMENTS}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "documents.messages.errors.delete";
    }
  }
};
